import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from 'src/store/auth'

export const PrivateRoute = ({ route }) => {
  const user = useAuthStore((store) => store.user)

  const userData = user || JSON.parse(window.localStorage.getItem('user'))

  const isAvailableRoute = route?.meta?.roles?.includes(userData?.role)

  return userData && isAvailableRoute ? <Outlet /> : <Navigate to='/' />
}
